export enum EConfigsTab {
  CALLBACK = 'callback',
  SETTINGS = 'settings',
}

export const CONFIGS_TABS = Object.values(EConfigsTab);
